import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Rapportera sidan',
  title: 'Rapportera ett problem med sidan',
  reasons: {
    'inaccurate-or-fabricated': 'Felaktig eller påhittad information',
    'wrong-product': 'Produkterna stämmer inte med sidan',
    'sexually-explicit': 'Sexuellt explicit innehåll',
    'regulated-product': 'Receptbelagd eller reglerad produkt',
    'dangerous-product': 'Farlig produkt',
    'ip-infringement': 'Gör intrång i mina rättigheter (varumärke/upphovsrätt)',
    other: 'Något annat',
  },
  detail: 'Detaljer (valfritt)',
  submit: 'Skicka rapport',
  cancel: 'Avbryt',
  sent: 'Tack. Vi går igenom rapporter inom 24 timmar.',
  failed: 'Det gick inte att skicka rapporten. Försök igen.',
};
